import * as actionType from '../constants/constant.action'

const defaultState = {}

const submitReferralReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.PROVIDER_SUBMIT_REFERRAL_REQUEST:
      return {
        ...state,
        isSubmitted: false,
      }
    case actionType.PROVIDER_SUBMIT_REFERRAL_FAILURE:
      return {
        ...state,
        failureResponse: action.payload,
        successResponse: '',
        isSubmitted: true,
      }
    case actionType.PROVIDER_SUBMIT_REFERRAL_SUCCESS:
      if (action.payload.response && action.payload.response.status === 500) {
        return {
          ...state,
          successResponse: action.payload,
          failureResponse: '',
          serverError: true,
          isSubmitted: true,
        }
      }
      if (action.payload.data.resultCode === 'CEN_5008') {
        return {
          ...state,
          successResponse: action.payload,
          failureResponse: '',
          serverError: true,
          isSubmitted: true,
        }
      }
      return {
        ...state,
        successResponse: action.payload,
        failureResponse: '',
        isSubmitted: true,
      }

    default:
      return state
  }
}

export default submitReferralReducer
